<template>
    <div class="events-month">
        <table class="month month-grid">
            <thead>
            <tr class="monthNav">
                <th colspan="7">
                    <a
                        v-if="mayLinkPrev"
                        v-html="'&laquo;'"
                        :href="prevLink"
                        :title="prevLabel"
                    />
                    <span
                        v-else
                        class="disabled"
                        v-html="'&laquo;'"
                    />

                    {{ monthLabel }}

                    <a
                        v-if="mayLinkNext"
                        v-html="'&raquo;'"
                        :href="nextLink"
                        :title="nextLabel"
                    />
                    <hr>
                </th>
            </tr>
            <tr class="weekdays">
                <th
                    v-for="iDay in 7"
                    v-text="weeks[0][iDay - 1].weekday"
                />
            </tr>
            </thead>
            <tbody>
            <tr v-for="(week, iWeek) in weeks" :key="iWeek">
                <td
                    v-for="(day, iDay) in week"
                    :key="iWeek + '_' + iDay"
                    :class="{offMonth: day.offMonth}"
                >
                    <div class="dayNumber" v-text="day.label" />
                    <a
                        v-for="event in day.events"
                        :href="getUrlForEvent(event)"
                        class="events"
                        todo="'tooltip'"
                        v-html="event.title"
                    />

                </td>
            </tr>
            </tbody>
        </table>
        <p
            v-if="loading"
            v-text="'Loading...'"
        />
    </div>
</template>

<script>

import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
// import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
// import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isBetween);
// dayjs.extend(isSameOrBefore);
// dayjs.extend(isSameOrAfter);

export default {
    props: {
        events: {
            type: Array,
            default: () => [],
        },
        eventType: {
            type: String,
            default: '',
        },
        month: {
            type: String,
            default: dayjs().format('YYYYMM'),
        },
        earliest: {
            type: String,
            default: dayjs().subtract(2, 'year').format('YYYYMM'),
        },
        latest: {
            type: String,
            default: dayjs().add(2, 'year').format('YYYYMM'),
        },
        loading: {
            type: Boolean,
        },
    },
    
    computed: {
        mayLinkPrev() {
            return this.month > this.earliest;
        },
        mayLinkNext() {
            return this.month < this.latest;
        },
        prevLink() {
            return '/' + (this.eventType || 'events')
                + '/' + dayjs(this.month, 'YYYYMM').subtract(1, 'month').format('YYYYMM')
                + '#calendar';
        },
        prevLabel() {
            return dayjs(this.month, 'YYYYMM').subtract(1, 'month').format('MMMM YYYY');
        },
        monthLabel() {
            return dayjs(this.month, 'YYYYMM').format('MMMM YYYY');
        },
        nextLink() {
            return '/' + (this.eventType || 'events')
                + '/' + dayjs(this.month, 'YYYYMM').add(1, 'month').format('YYYYMM')
                + '#calendar';
        },
        nextLabel() {
            return dayjs(this.month, 'YYYYMM').add(1, 'month').format('MMMM YYYY');
        },


        firstDate() {
            return dayjs(this.month, 'YYYYMM').startOf('month').startOf('week');
        },
        lastDate() {
            return dayjs(this.month, 'YYYYMM').endOf('month').endOf('week');
        },
        weeks() {
            let weeks = [];
            let date = this.firstDate.clone();
            while (date <= this.lastDate) {
                const iWeek = date.diff(this.firstDate, 'week');
                const iDay = date.format('d');
                if (!weeks[iWeek]) {
                    weeks[iWeek] = [];
                }
                weeks[iWeek][iDay] = {
                    label: date.format('D'),
                    weekday: date.format('ddd'),
                    offMonth: date.format('YYYYMM') !== this.month,
                    events: this.getEventsForDate(date),
                }
                date = date.add(1, 'day');
            }
            return weeks;
        },
    },

    methods: {
        getEventsForDate(date) {
            return this.events.filter(event =>
                event.series.some(serie =>
                    serie.sessions.some(session =>
                        date.isBetween(dayjs(session.dateStart), dayjs(session.dateEnd), 'day', '[]')
                    )
                )
            );
        },

        getUrlForEvent(event) {
            return '/' + (this.eventType || 'events') + '/' + event.slug;
        },
    },
}
</script>

<style lang="scss">
.events-month {
}
</style>
